<template>
    <address>
      <span v-if="groupAddress != '' && groupAddress1 === undefined" v-html="groupAddress.replace(/(?:\r\n|\r|\n)/g, '<br>')" class="shortp"></span>
      <span v-if="groupAddress1 != ''">{{groupAddress1}}</span>
      <span v-if="groupAddress2 != ''">{{groupAddress2}}</span>
      <span v-if="groupCityRegion != ''">{{groupCityRegion}}</span>
      <span v-if="groupCountyState != ''">{{groupCountyState}}</span>
      <span v-if="groupPostcode != ''">{{groupPostcode}}</span>
      <span v-if="groupCountry != ''">{{groupCountry}}</span>
    </address>
</template>

<script>
export default {
  name: 'AddressDisplay',
  props: [
    'groupAddress',
    'groupAddress1',
    'groupAddress2',
    'groupCityRegion',
    'groupCountyState',
    'groupPostcode',
    'groupCountry'
  ]
}
</script>
<style scoped>
address{
  font-style: normal;
}
span {
  display:block;
}
</style>
